import React, { FunctionComponent } from "react"

import { useFormContext } from "react-hook-form"
import classnames from "classnames"

import "./styles.scss"

const criticalityLevel = {
  "n/a": "low",
  possibly: "medium",
  applicable: "high"
}

interface Props {
  text: string
  labelId: string
  onPillChange: Function
  type: string
  pillGroupName?: string
  currentPillTextSelected?: string
}
const PillRadio: FunctionComponent<Props> = ({
  text,
  labelId,
  type = "",
  pillGroupName = "",
  onPillChange,
  currentPillTextSelected
}) => {
  const { register } = useFormContext()

  // pill id includes group name in id if set - used to group appropriate radio buttons
  // under `name` so that radio button toggles appropriately for the group
  const fullPillId = pillGroupName ? `${pillGroupName}-${labelId}` : labelId
  const isSelected = currentPillTextSelected === text.toLowerCase()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onPillChange(event.target.value.toLowerCase(), type)
  }
  return (
    <React.Fragment>
      <label
        key={fullPillId}
        htmlFor={fullPillId}
        className={classnames(
          `pill ${isSelected ? "selected" : ""}`,
          criticalityLevel[type]
        )}
      >
        {text}
        <input
          key={fullPillId}
          type="radio"
          name={pillGroupName}
          id={fullPillId}
          value={text.toLowerCase()}
          onChange={handleChange}
          defaultChecked={currentPillTextSelected === text.toLowerCase()}
          className="visually-hidden"
          ref={register({ required: true })}
        ></input>
      </label>
    </React.Fragment>
  )
}
export default PillRadio
